import { render, staticRenderFns } from "./settingFreight.vue?vue&type=template&id=247b8d58&scoped=true"
import script from "./settingFreight.vue?vue&type=script&lang=js"
export * from "./settingFreight.vue?vue&type=script&lang=js"
import style0 from "./settingFreight.vue?vue&type=style&index=0&id=247b8d58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b8d58",
  null
  
)

export default component.exports